import ReportUtils from "../../../../utils/report-utils.js";
import GraphicUtils from "../../../../utils/graphic-utils.js";

const statusObj = {
  ACTIVATED: "Ativo",
  INACTIVATED: "Inativo"
}
export const statusObjArr = Object.entries(statusObj).map(([key,value]) => ({label: value, value: key}));

export const cardLabels = [
  "Cadastros com acionamento",
  "Acionamentos",
  "Despachos gerados",
  "Indivíduos presos",
  "Tempo médio para despacho",
]
export const reportsInfo = {
  sosRegistrationChart: {
    reportName: "Cadastro de Cidadãos/Empresas",
    reportId : "sos-registration"
  },

  inactivationRegistrationReason: {
    reportName: "Motivo da inativação dos cadastros",
    reportId : "inactivation-registration-reason"
  },

  lifeRisk: {
    reportName: "Grau de risco das medidas protetivas",
    reportId: "life-risk"
  },

  registrationByProtectionType: {
    reportName: "Cadastros por programa de proteção",
    reportId: "registration-by-protection-type"
  },

  registrationByViolenceType: {
    reportName: "Cadastros por tipo de violência",
    reportId: "registration-by-violence-type"
  },

  familyRelationship: {
    reportName: "Vínculo do agressor com o protegido",
    reportId: "family-relationship"
  },

  protectionByEvents: {
    reportName: "Acionamentos por tipo de proteção",
    reportId: "protection-by-events"
  },

  eventsByWeekDay: {
    reportName: "Acionamento por dia de semana com intervalo de 1 hora",
    reportId: ""
  },

  citizensByAge: {
    reportName: "Cadastro de protegidos por faixa etária",
    reportId: "citizens-by-age"
  },

  citizensByNeighborhood: {
    reportName: "Cadastro de protegidos por bairros",
    reportId: "citizens-by-neighborhood"
  },

  providenceByEvent: {
    reportName: "Providência após acionamento",
    reportId: "providence-by-event"
  },
}
export function exportData(data, boName) {
  const details = Array.isArray(data) ? data : [];
  const headers = ["ID", "Acionamento", "Nome do cidadão", "Status", "Idade", "Grau de risco", "Programa de proteção",
    "Assumido", "Usuário que assumiu", "Providência", "ID do despacho", "Tempo para despacho", boName, "Indivíduos presos", "Endereço"];

  const rows = details.map(item => [
    item.id,
    item.dt_sos,
    item.name,
    item.status,
    item.age,
    item.life_risk,
    item.protection_program,
    item.dt_ack,
    item.user_ack,
    item.providence,
    item.dispatch_id,
    item.avg_dispatch_time,
    item.bo,
    item.ind_arrested,
    item.fact_address
  ])

  ReportUtils.createExportableTable(headers, rows, "Informações gerais");
}

export function exportCards(data, boName){
  const cards = data ?? {};
  const headers = [...cardLabels];
  headers.splice(4, 0, boName);

  const rows = [
    cards.registrations ?? 0,
    cards.events ?? 0,
    cards.dispatchs ?? 0,
    cards.ind_arrested ?? 0,
    cards.bos ?? 0,
    cards.avg_dispatch_time ?? "0s"
  ]

  ReportUtils.createExportableTable(headers, rows, "Cards");
}